<!-- 用来作为统一认证中心，内门户中下载移动平台，扫码判断设备，跳转相应下载页面 -->
<template>
  <div>
    <el-row v-show="isToBrowser" class="home-bg">
      <img src="~@/assets/images/download/to.png">
    </el-row>
  </div>
</template>

<script>
import {checkBrowser, downloadFile} from '@/util/index'
import {getDownloadApp, downloadIosUrl} from '@/util/api'

export default { 
  data() {
    return {
      isToBrowser: false,
      downloadIosUrl
    }
  }, 
  created() {
    this.getApp()
  },
  methods: {
    getApp() {
      let {ios, mobile, weixin} = checkBrowser()
      this.isToBrowser = false
      if (weixin) {
        this.isToBrowser = true
      } else if (ios) {
        getDownloadApp({platform: 'ios'}).then(res => {
          if(res.code == 0) {
            let appId = res.data.split('_')[0]
            let version = res.data.split('_')[1]
            let plistUrl = `${downloadIosUrl}/poros-mobile/appVersion/plist/${appId}/${version}.plist`
            downloadFile(`itms-services://?action=download-manifest&url=${plistUrl}`)
          } else {
            this.$message.error(res.msg)
          }
        }) 
      } else if (mobile) {
        getDownloadApp({platform: 'android'}).then(res=>{
          if(res.code == 0) {
            window.location = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
      } 
    }
  },
}
</script>

<style scoped lang="less"> 
.home-bg{
  background: rgba(0,0,0,0.50);
  width: 100vw;
  height: 100vh;
  position: relative;
  img{
    position: absolute;
    right: 8vw;
    top: 4vh;
    width: 36vw;
    display: inline-block;
  }
}
</style>
